module.exports = __webpack_public_path__ + "static/a_train-b01a73c4b7001c0ce4ab09ddf78b40d9.jpg";